import styled from 'styled-components';
import { useHelpScout } from 'src/utils/hooks';
import i18n from 'src/utils/translate';
import Icon from 'src/components/icon';
import { LinkButton } from 'styles-js/buttons';

export default function RepliesTurnedOffNotice() {
  return (
    <Container>
      <BigIcon icon="alert" />
      <Text>
        <p>{i18n.t('The ability to reply to this post has been turned off.')}</p>
        <LinkButton onClick={() => useHelpScout('21-why-was-replying-turned-off')}>{i18n.t('Learn more')} <Icon icon="right-open" /></LinkButton>
      </Text>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  background-color: ${({theme}) => theme.colorBlueBackground};
  margin-bottom: 25px;
`;
const BigIcon = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.colorBlue};
  color: ${({theme}) => theme.colorWhite};
  font-size: 34px;
  padding: 15px;
`;
const Text = styled.div`
  padding: 15px;
`;
